import GenerativeAIMedpalm from "./GenerativeAIMedpalm";

export default GenerativeAIMedpalm;